import React, { useState } from 'react';
import { Container, Modal, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import '../../assets/css/general/footer.css';

const Footer = () => {
    const navigate = useNavigate();
    const [showImageModal, setShowImageModal] = useState(false);
    const [showTermsModal, setShowTermsModal] = useState(false);
    const [modalImage, setModalImage] = useState('');
    const [modalTitle, setModalTitle] = useState('');
    const [modalType, setModalType] = useState('');
    const [modalContent, setModalContent] = useState('');

    // Contact Info
    const contactInfo = [
        {
            icon: 'fas fa-phone',
            label: 'Mobile Number',
            value: '0328-1334874'
        },
        {
            icon: 'fas fa-envelope',
            label: 'Email Address',
            value: 'journeyjunction@gmail.com'
        },
        {
            icon: 'fas fa-clock',
            label: 'Working Hours',
            value: '9:00 AM - 6:00 PM'
        }
    ];

    const socialLinks = [
        { icon: 'fab fa-tiktok', tooltip: 'TikTok' },
        { icon: 'fab fa-instagram', tooltip: 'Instagram' },
        { icon: 'fab fa-youtube', tooltip: 'YouTube' },
        { icon: 'fab fa-whatsapp', tooltip: 'WhatsApp' }
    ];

    const galleryImages = [
        {
            src: 'https://images.unsplash.com/photo-1551632811-561732d1e306?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
            fullSrc: 'https://images.unsplash.com/photo-1551632811-561732d1e306?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
            name: 'Hunza Valley'
        },
        {
            src: 'https://images.unsplash.com/photo-1528164344705-47542687000d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
            fullSrc: 'https://images.unsplash.com/photo-1528164344705-47542687000d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
            name: 'Skardu'
        },
        {
            src: 'https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
            fullSrc: 'https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
            name: 'Fairy Meadows'
        },
        {
            src: 'https://images.unsplash.com/photo-1506744038136-46273834b3fb?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
            fullSrc: 'https://images.unsplash.com/photo-1506744038136-46273834b3fb?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
            name: 'Naran Valley'
        },
        {
            src: 'https://images.unsplash.com/photo-1548013146-72479768bada?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
            fullSrc: 'https://images.unsplash.com/photo-1548013146-72479768bada?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
            name: 'Swat Valley'
        },
        {
            src: 'https://images.unsplash.com/photo-1464278533981-50106e6176b1?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
            fullSrc: 'https://images.unsplash.com/photo-1464278533981-50106e6176b1?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
            name: 'Deosai Plains'
        }
    ];

    

    // Quick Links
    const quickLinks = [
        { icon: 'fas fa-question-circle', text: 'Frequently Asked Questions', type: 'faq' },
    ];

    // Footer Links
  const footerLinks = [
    { text: 'Terms of Service', path: '/terms-and-conditions' },
    { text: 'Privacy Policy',   path: '/privacy-policy' },
   
];

    // Handle FAQ Click
    const handleFAQClick = () => {
        navigate('/faqs', { 
            replace: true, 
            state: { scrollToTop: true } 
        });
    };

    // Handle Image Modal
    const handleImageClick = (fullSrc, name) => {
        setModalImage(fullSrc);
        setModalTitle(name);
        setShowImageModal(true);
    };

    // Handle Terms Modal
    const handleTermsClick = (type, path) => {
         if (path) {
        navigate(path);
        return;
    }
        if (type === 'faq') {
            handleFAQClick();
            return;
        }
        
        setModalType(type);
        
        let content = '';
        let title = '';
        
        switch(type) {
            case 'privacy':
                title = 'Privacy Policy & Data Protection';
                content = `
                    <div class="ft-terms-modal-section">
                        <h3>Data Collection</h3>
                        <p>We collect information that you provide directly to us when you:</p>
                        <ul>
                            <li>Create an account or profile</li>
                            <li>Make bookings or purchases</li>
                            <li>Contact our customer service</li>
                            <li>Participate in surveys or promotions</li>
                        </ul>
                    </div>
                    <div class="ft-terms-modal-section">
                        <h3>Data Protection</h3>
                        <p>We implement appropriate technical and organizational security measures to protect your personal data against unauthorized access, alteration, disclosure, or destruction.</p>
                    </div>
                    <div class="ft-terms-modal-section">
                        <h3>Your Rights</h3>
                        <p>You have the right to access, correct, or delete your personal data. </p>
                    </div>
                `;
                break;
                
            case 'contact':
                title = 'Contact Support';
                content = `
                    <div class="ft-terms-modal-section">
                        <h3>Customer Support</h3>
                        <p>Our customer support team is available to assist you with any questions or concerns:</p>
                        <ul>
                            <li><strong>Email:</strong> support@northern.pk</li>
                            <li><strong>Phone:</strong> +92 300 123 4567</li>
                            <li><strong>WhatsApp:</strong> +92 300 123 4567</li>
                            <li><strong>Office Hours:</strong> 9:00 AM - 6:00 PM (PKT)</li>
                        </ul>
                    </div>
                    <div class="ft-terms-modal-section">
                        <h3>Response Time</h3>
                        <p>We strive to respond to all inquiries within 24 hours during business days.</p>
                    </div>
                `;
                break;
                
            case 'cookies':
                title = 'Cookie Policy';
                content = `
                    <div class="ft-terms-modal-section">
                        <h3>What Are Cookies</h3>
                        <p>Cookies are small text files that are placed on your computer or mobile device when you visit our website.</p>
                    </div>
                    <div class="ft-terms-modal-section">
                        <h3>How We Use Cookies</h3>
                        <ul>
                            <li>To remember your preferences</li>
                            <li>To understand how you use our website</li>
                            <li>To improve user experience</li>
                            <li>For analytics purposes</li>
                        </ul>
                    </div>
                    <div class="ft-terms-modal-section">
                        <h3>Cookie Control</h3>
                        <p>You can control and/or delete cookies as you wish. You can delete all cookies that are already on your computer and you can set most browsers to prevent them from being placed.</p>
                    </div>
                `;
                break;
                
            case 'disclaimer':
                title = 'Disclaimer';
                content = `
                    <div class="ft-terms-modal-section">
                        <h3>Content Accuracy</h3>
                        <p>While we make every effort to ensure the accuracy of information on our website, we cannot guarantee that all information is completely accurate, complete, or current.</p>
                    </div>
                `;
                break;
                
            case 'terms':
            default:
                title = 'Terms of Service';
                content = `
                    <div class="ft-terms-modal-section">
                        <h3>Acceptance of Terms</h3>
                        <p>By accessing and using this website, you accept and agree to be bound by these Terms of Service. If you do not agree, please do not use our services.</p>
                    </div>
                    <div class="ft-terms-modal-section">
                        <h3>Service Description</h3>
                        <p>Northern Pakistan Gallery provides tourism information, booking services, and photographic content related to Northern Pakistan's destinations.</p>
                    </div>
                    <div class="ft-terms-modal-section">
                        <h3>User Conduct</h3>
                        <p>Users agree not to use the service for any unlawful purpose or in any way that might harm, damage, or disparage Northern Pakistan Gallery.</p>
                    </div>
                    <div class="ft-terms-modal-section">
                        <h3>Modifications</h3>
                        <p>We reserve the right to modify these terms at any time. Continued use of the website after changes constitutes acceptance of the modified terms.</p>
                    </div>
                `;
        }
        
        setModalContent(content);
        setModalTitle(title);
        setShowTermsModal(true);
    };

    // Handle Social Media Click
    const handleSocialClick = (platform) => {
        alert(`You clicked on ${platform} (Demo link)`);
    };

    return (
        <>
            {/* Footer Container */}
            <footer className="ft-footer-container" id="main-footer">
                <Container fluid className="p-0">
                    <div className="ft-footer-layout">
                        {/* Contact Section */}
                        <div className="ft-contact-column">
                            <h3 className="ft-section-title">Contact Info</h3>
                            <div className="ft-contact-info">
                                {contactInfo.map((item, index) => (
                                    <div className="ft-contact-item" key={index}>
                                        <div className="ft-contact-icon">
                                            <i className={item.icon}></i>
                                        </div>
                                        <div className="ft-contact-text">
                                            <div className="ft-contact-label">{item.label}</div>
                                            <div className="ft-contact-value">{item.value}</div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Social Media Section */}
                        <div className="ft-social-column">
                            <h3 className="ft-section-title">Social Media</h3>
                            <div className="ft-social-icons">
                                {socialLinks.map((link, index) => (
                                    <a 
                                        href="#" 
                                        className={`ft-social-link ft-${link.tooltip.toLowerCase()}`}
                                        key={index}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleSocialClick(link.tooltip);
                                        }}
                                    >
                                        <i className={link.icon}></i>
                                        <span className="ft-social-tooltip">{link.tooltip}</span>
                                    </a>
                                ))}
                            </div>
                        </div>

                        {/* Gallery Section */}
                        <div className="ft-gallery-column">
                            <h3 className="ft-section-title">Gallery</h3>
                            <div className="ft-gallery-grid">
                                {galleryImages.map((image, index) => (
                                    <div 
                                        className="ft-gallery-item" 
                                        key={index}
                                        onClick={() => handleImageClick(image.fullSrc, image.name)}
                                    >
                                        <img src={image.src} alt={image.name} />
                                        <div className="ft-gallery-overlay">
                                            <span className="ft-image-name">{image.name}</span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Terms & Conditions Section */}
                        <div className="ft-terms-column">
                            <h3 className="ft-section-title">Quick Links</h3>
                            <div className="ft-terms-content">
                                <div className="ft-quick-links">
                                    {quickLinks.map((link, index) => (
                                        <div 
                                            className="ft-quick-link" 
                                            key={index}
                                            onClick={() => handleTermsClick(link.type, link.path)}
                                        >
                                            <i className={link.icon}></i>
                                            <span>{link.text}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Footer Bottom */}
                    <div className="ft-footer-bottom">
                        <div className="ft-footer-links">
                            {footerLinks.map((link, index) => (
                                <span 
                                    className="ft-footer-link" 
                                    key={index}
                                    onClick={() => handleTermsClick(link.type, link.path)}
                                >
                                    {link.text}
                                </span>
                            ))}
                        </div>
                    </div>
                </Container>
            </footer>

            {/* Image Modal */}
            <Modal 
                show={showImageModal} 
                onHide={() => setShowImageModal(false)}
                centered
                size="lg"
                className="ft-image-modal"
                backdrop="static"
            >
                <Modal.Body className="p-0">
                    <div className="ft-modal-content">
                        <button 
                            className="ft-modal-close" 
                            onClick={() => setShowImageModal(false)}
                        >
                            ×
                        </button>
                        <img 
                            className="ft-modal-img" 
                            src={modalImage} 
                            alt={modalTitle} 
                        />
                        <div className="ft-modal-title">{modalTitle}</div>
                    </div>
                </Modal.Body>
            </Modal>

            {/* Terms Modal */}
            <Modal 
                show={showTermsModal} 
                onHide={() => setShowTermsModal(false)}
                centered
                size="lg"
                className="ft-terms-modal"
                backdrop="static"
            >
                <div className="modal-content">
                    <Modal.Header className="ft-terms-modal-header">
                        <Modal.Title className="ft-terms-modal-title">
                            {modalTitle}
                        </Modal.Title>
                        <Button 
                            variant="link" 
                            className="ft-terms-modal-close"
                            onClick={() => setShowTermsModal(false)}
                        >
                            ×
                        </Button>
                    </Modal.Header>
                    <Modal.Body 
                        className="ft-terms-modal-body"
                        dangerouslySetInnerHTML={{ __html: modalContent }}
                    />
                </div>
            </Modal>
             
        </>
       
    );
    
};


export default Footer;